import * as React from 'react';
import * as ReactDom from 'react-dom';

export interface CalendarItemData {
    day: number;
    active: boolean;
    occupied: OccupiedStates;
}

export enum OccupiedStates {
    AllRoomsAvailable = 0,
    OneRoomLeft,
    TwoRoomsLeft,
    MoreThenTwoRoomsLeft,
    Occupied
}

export interface CalendarRowData {
    row: CalendarItemData[];
}

export class CalendarItem extends React.Component<CalendarItemData> {

    constructor(props: CalendarItemData) {
        super(props);
    }

    render() {
        const className = this.props.active ? 'calendarItemActive' : 'calendarItemInactive';
        const classNameBrushed = OccupiedStates[this.props.occupied];

        return <td className={className}>
            <div className={classNameBrushed}>{this.props.day}</div>
        </td>;
    }
}

export class CalendarRow extends React.Component<CalendarRowData> {

    constructor(props: CalendarRowData) {
        super(props);
    }

    render() {
        return <tr>
            {this.props.row.map(item => <CalendarItem day={item.day} active={item.active} occupied={item.occupied} />)}
        </tr>;
    }
}

export class CalendarHeader extends React.Component {
    render() {
        const headerData = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'];
        const header = headerData.map(item => <td className='calHeader'>{item}</td>);

        return <thead><tr>{header}</tr></thead>;
    }
}

export interface DateRange {
    startDate: Date;
    endDate: Date;
}

export interface CalendarData {
    dateToDisplay: Date;
    datesOccupied: [DateRange[]];
}

export class Calendar extends React.Component<CalendarData> {

    occupiedDates: [DateRange[]];
    countCalendars: number;

    constructor(props: CalendarData) {
        super(props);

        const dateToShow = props.dateToDisplay;

        props.datesOccupied.forEach(y => y.filter(x => x.endDate >= dateToShow));
        this.occupiedDates = props.datesOccupied;
        this.countCalendars = props.datesOccupied.length;
    }

    isInRange(range: DateRange, year: number, month: number, day: number) {
        let dateToShow = new Date(year, month, day);

        if (dateToShow >= range.startDate && dateToShow <= range.endDate) {
            return true;
        }

        return false;
    }

    render() {

        const length = new Array(31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
        if (lang === "en") {
            var monthNames = new Array("January", "February", "March", "April", "Mai", "June", "July", "August", "September", "October", "November", "December");
        } else {
            var monthNames = new Array("Januar", "Februar", "Maerz", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember");
        }

        let today = this.props.dateToDisplay;

        const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
        const lastDayDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        const lastDay = lastDayDate.getDate();

        const lastDayDateOfMonthBefore = new Date(today.getFullYear(), today.getMonth(), 0);
        const lastDayOfMonthBefore = lastDayDateOfMonthBefore.getDate();

        let dayOfWeek = firstDay.getDay() == 0 ? 6 : firstDay.getDay() - 1;
        let day = today.getDate();
        let month = today.getMonth();
        let year = today.getFullYear();

        let calDays: Array<CalendarItemData> = [];
        const numberCalCells = 42;
        let rows: JSX.Element[] = [];
        let nextMonthCount = 0;

        for (let i = 0; i < numberCalCells; i++) {

            const occupied = this.occupiedDates.map(y => y.filter(x => this.isInRange(x, year, month, i - dayOfWeek + 1)).length > 0 ? 1 : 0).reduce((a, b) => a + b, 0);
            //const occupied = true;//this.occupiedDates.filter(x => this.isInRange(x, year, month, i - dayOfWeek + 1)).length > 0;
            let state: OccupiedStates;
            switch (this.countCalendars - occupied) {
                case 0:
                    state = OccupiedStates.Occupied;
                    break;
                case 1:
                    state = OccupiedStates.OneRoomLeft;
                    break;
                // case 2:
                //     state = OccupiedStates.TwoRoomsLeft;
                default:
                    state = OccupiedStates.AllRoomsAvailable;
                // if (occupied === 0) {
                //     state = OccupiedStates.AllRoomsAvailable;
                // } else {
                //     state = OccupiedStates.OneRoomLeft;
                // }
            }

            let calItem: CalendarItemData = { day: 0, active: true, occupied: state };

            if (i >= dayOfWeek) {

                calItem.day = i - dayOfWeek + 1;

            } else {
                calItem.day = lastDayOfMonthBefore - dayOfWeek + i + 1;
                calItem.active = false;
                calItem.occupied = OccupiedStates.AllRoomsAvailable;;

            }

            if (i >= (lastDay + dayOfWeek)) {

                calItem.day = ++nextMonthCount;
                calItem.active = false;
                calItem.occupied = OccupiedStates.AllRoomsAvailable;
            }

            calDays.push(calItem);

            if (i > 0 && (i + 1) % 7 == 0) {

                let calendarRow = <CalendarRow row={calDays} />;

                rows.push(calendarRow);
                calDays = [];
            }
        }

        return <div>
            <div className="title">{monthNames[month]} {year}</div>
            <table className="calendar">
                <CalendarHeader />
                <tbody>
                    {rows}
                </tbody>
            </table>
        </div>;
    }
}

export class CalendarContainer extends React.Component<CalendarData, CalendarData> {

    btnRight = "img/btn_right.png";
    btnLeft = "img/btn_left.png";

    constructor(props: CalendarData) {
        super(props);

        this.state = { dateToDisplay: props.dateToDisplay, datesOccupied: props.datesOccupied };
    }

    render() {

        return <div className="CalenderContainer">
            <div className="btn" onClick={() => {
                const curDate = new Date();
                if (this.state.dateToDisplay.getFullYear() > curDate.getFullYear() ||
                    (this.state.dateToDisplay.getMonth() > curDate.getMonth() && this.state.dateToDisplay.getFullYear() === curDate.getFullYear()))
                    this.setState({ dateToDisplay: new Date(this.state.dateToDisplay.getFullYear(), this.state.dateToDisplay.getMonth() - 1) });
            }
            }>
                <img src={this.btnLeft} />
            </div>

            <div className="CalendarMain">
                <Calendar dateToDisplay={this.state.dateToDisplay} datesOccupied={this.state.datesOccupied} />
                <Calendar dateToDisplay={new Date(this.state.dateToDisplay.getFullYear(), this.state.dateToDisplay.getMonth() + 1)} datesOccupied={this.state.datesOccupied} />
            </div>

            <div className="btn" onClick={() => {
                this.setState({ dateToDisplay: new Date(this.state.dateToDisplay.getFullYear(), this.state.dateToDisplay.getMonth() + 1) });
            }
            }><img src={this.btnRight} /></div>
        </div>;
    }
}
// function GetCalendarDates(): [DateRange[]] {
//     return [
//         [{ startDate: new Date("2017-11-05"), endDate: new Date("2017-11-11") }],
//         [{ startDate: new Date("2017-11-05"), endDate: new Date("2017-11-07") },
//         { startDate: new Date("2017-11-07"), endDate: new Date("2017-11-14") }],
//         []
//     ]
// };

var date = new Date();
var lang = "en";
let dates: [DateRange[]] = GetCalendarDates();
ReactDom.render(<CalendarContainer dateToDisplay={new Date(date.getFullYear(), date.getMonth())} datesOccupied={dates} />, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/app.tsx